export enum ColumnType {
  TEXT = 'TEXT',
  COMPONENT = 'COMPONENT',
}

export enum ContentPosition {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export const ContentPositionClassNames = {
  [ContentPosition.LEFT]: 'ui-table-cell--text-position-left',
  [ContentPosition.RIGHT]: 'ui-table-cell--text-position-right',
  [ContentPosition.CENTER]: 'ui-table-cell--text-position-center',
};

export enum SortingDirection {
  NONE = 'NONE',
  ASC = 'ASC',
  DESC = 'DESC',
}
